<template>
  <div class="padding">
    <!-- <FormInput
      v-model="$v.site.$model"
      :disabled="disabled"
      :vuelidate="$v"
      fieldName="site"
      :ske="true"
      :focus="true"

      id="site"
      label="Website"
    /> -->
    <div class="d-flex">
      <FormSearchSelector v-model="$v.site.$model"
        class="sm form-element"
        id="website"
        label="Website"
        placeholder="Zoek website..."
        endpoint="/api/websites"
        titleField="domainname"
        max-height="370px"
        :ske="editing"
        :disabled="disabled || showRemark"
        :initial-search-value="$v.siteName.$model"
        :get-name-from-endpoint="true"

        @select-item="getWebsiteName"

        :infinite-scrolling="true"

        v-slot="item"
      >
        <div class="px-2 item">
          {{ item.domainname }}
        </div>
      </FormSearchSelector>

      <FormInput v-if="!showRemark"
        class="sm form-element"
        v-model="$v.orderNumber.$model"
        :disabled="true"
        :ske="true"
        :vuelidate="$v"
        fieldName="orderNumber"

        id="orderNumber"
        label="Bestellingsnummer"
      />
      <FormInput v-else
        class="sm form-element"
        v-model="vuelidate.orderNumber.$model"
        :disabled="true"
        :ske="true"
        :vuelidate="$v"
        fieldName="orderNumber"

        id="orderNumber"
        label="Bestellingsnummer"
      />
    </div>
    <FormTextarea v-if="showRemark"
      v-model="vuelidate.remark.$model"
      placeholder="Remark..."
      class="mt-3"
      :ske="true"
      :disabled="disabled"
      rows="17"

      ref="textarea"
    />
    <!-- <div class="d-flex">
      <FormSelect
        class="sm form-element"
        v-model="$v.language.$model"
        :disabled="disabled"
        :ske="true"
        :vuelidate="$v"
        :options="shortLanguageOptions"
        fieldName="language"

        id="language"
        label="Taal"
      />
    </div> -->
    <!-- <FormInput
      v-model="$v.shipmentTrackAndTrace.$model"
      :disabled="disabled"
      :ske="true"
      :vuelidate="$v"
      fieldName="shipmentTrackAndTrace"

      id="shipmentTrackAndTrace"
      label="Track en trace"
    /> -->
  </div>
</template>

<script>

import FormInput from "/src/components/Inputs/FormInput.vue"
import FormTextarea from "/src/components/Inputs/FormTextarea.vue"
import FormSelect from "../Inputs/FormSelect.vue"
import WebsiteItem from "../../pages/website-products/Table/WebsitesColumn/WebsiteItem.vue"
import FormSearchSelector from "../Inputs/FormSearchSelector.vue"
import ProductListItem from "../Product/ProductListItem.vue"

import setupForm from "../../mixins/setupForm"
import { required } from "vuelidate/lib/validators"

import tableFieldOptions from "../../mixins/tableFieldOptions"

const decimal = value => (value + "").replace(/,/, ".").match(/^[-]?\d*(\.\d+)?$/) ? true : false

export default setupForm(
  ["site", "orderDate", "orderNumber", "language", "siteName"], {
  mixins: [tableFieldOptions],
  components: {
    FormSelect,
    ProductListItem,
    FormInput,
    FormSearchSelector,
    FormTextarea,
  },
  props: {
    disabled: Boolean,
    loading: Boolean,
    editing: Boolean,
    showRemark: Boolean,
    vuelidate: Object,
  },
  data() {
    return {
      language: "NL",
    }
  },

  async mounted() {
    if (!this.showRemark) {
      await this.getOrderNumber()
    } else {
      this.$v.siteName.$model = this.$v.site.$model
    }
  },
  methods: {
    async getOrderNumber() {
      const {data: { orderNumber } } = await this.axios.get('/api/orders/next-order-number')
      this.$v.orderNumber.$model = orderNumber
    },
    getWebsiteName(item) {
      if (!item) return;
      this.$v.siteName.$model = item.domainname
    },
  },
  watch: {
    loading(val) {
      if (!val) {
        this.$v.siteName.$model = this.$v.site.$model
      }
    },
  },
  validations: {
    siteName: {
      required,
    },
    remark: {
      
    },
    site: {
      required,
    },
    orderNumber: {
      required,
      decimal,
    },
    language: {
      required,
    },
  }
})

</script>

<style scoped src="@/assets/css/form.css"></style>

<style scoped>

.item {
  transition-duration: .15s;
}

.item:hover {
  background-color: rgba(243, 244, 246, 1) !important;
}

</style>
